var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8332 14.167C10.8332 14.6272 10.4601 15.0003 9.99984 15.0003C9.5396 15.0003 9.1665 14.6272 9.1665 14.167V4.51217L7.25576 6.42291C6.93032 6.74835 6.40268 6.74835 6.07725 6.42291C5.75181 6.09748 5.75181 5.56984 6.07725 5.2444L9.41058 1.91107C9.73602 1.58563 10.2637 1.58563 10.5891 1.91107L13.9224 5.2444C14.2479 5.56984 14.2479 6.09748 13.9224 6.42291C13.597 6.74835 13.0694 6.74835 12.7439 6.42291L10.8332 4.51217V14.167Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33317 9.16699C3.33317 8.70675 2.96007 8.33366 2.49984 8.33366C2.0396 8.33366 1.6665 8.70675 1.6665 9.16699V15.8337C1.6665 17.2144 2.78579 18.3337 4.1665 18.3337H15.8332C17.2139 18.3337 18.3332 17.2144 18.3332 15.8337V9.16699C18.3332 8.70675 17.9601 8.33366 17.4998 8.33366C17.0396 8.33366 16.6665 8.70675 16.6665 9.16699V15.8337C16.6665 16.2939 16.2934 16.667 15.8332 16.667H4.1665C3.70627 16.667 3.33317 16.2939 3.33317 15.8337V9.16699Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload2);
export default __webpack_public_path__ + "static/media/download2.2baf2208.svg";
export { ForwardRef as ReactComponent };